import React, { useMemo } from 'react';
import U2000ComboBoxBase from '../../../formControls/combobox/U2000ComboBoxBase';
import type { U2000CriteriaStaticOption } from '../../basic/U2000BasicTableList';

/** Libellé affiché pour un critère à options statiques (liste critères actifs, réédition). */
export function formatStaticCriteriaDisplayValue(
  value: unknown,
  options: U2000CriteriaStaticOption[],
): string {
  if (value == null || value === '') return '';
  const match = options.find((o) => o.value === String(value));
  return match?.label ?? String(value);
}

interface U2000CriteriaStaticOptionsComboProps {
  options: U2000CriteriaStaticOption[];
  value: string | null;
  onChange: (value: string, displayLabel?: string) => void;
  disabled?: boolean;
}

const U2000CriteriaStaticOptionsCombo: React.FC<U2000CriteriaStaticOptionsComboProps> = ({
  options,
  value,
  onChange,
  disabled = false,
}) => {
  const selected = useMemo(
    () => options.find((o) => o.value === (value ?? '')) ?? (value ? { value, label: value } : null),
    [options, value],
  );

  return (
    <U2000ComboBoxBase<U2000CriteriaStaticOption>
      data={options}
      keyField="value"
      descField="label"
      value={selected}
      onChangeObject={(opt) => onChange(opt?.value ?? '', opt?.label)}
      disabled={disabled}
    />
  );
};

export default U2000CriteriaStaticOptionsCombo;
